/**
 * Scroll page to top. If the virtual keyboard (on mobile devices)
 * is open - a delay on 500 ms is added else 10 ms
 */
export const scrollPageToTop = () => {
    setTimeout(
        () => {
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        },
        isVirtualKeyboardOpen() ? 500 : 10
    );
};

/**
 * Detect the virtual keyboard is open on mobile devices
 */
const isVirtualKeyboardOpen = () => {
    if (!window) {
        return false;
    }
    if (!window.visualViewport) {
        return false;
    }
    const minVirtualKeyboardHeight = 300;
    return window.screen.height - minVirtualKeyboardHeight > window!.visualViewport!.height;
};
